/**
 * Inline toast/banner used for query and submission feedback.
 * Variants: 'info' | 'success' | 'error'.
 */

import { byHook, hide, setText, show } from '../dom.js';

const VARIANTS = ['info', 'success', 'error'];

export const createToast = (root) => {
    const el = byHook('toast', root);
    let timer = null;

    const clear = () => {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };

    const apply = (variant) => {
        VARIANTS.forEach((v) => el.classList.toggle(`marc__toast--${v}`, v === variant));
    };

    return {
        show(message, variant = 'info', { autoHideMs = variant === 'error' ? 0 : 5000 } = {}) {
            clear();
            apply(variant);
            setText(el, message);
            show(el);
            if (autoHideMs > 0) {
                timer = setTimeout(() => hide(el), autoHideMs);
            }
        },
        hide() {
            clear();
            hide(el);
        },
    };
};
